import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { DatePicker, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const BirthDate = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const isEntity = useWatch({ control, name: `subjectsInfo.${index as 0}.isEntity` })

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.birthdate`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="19. Date of birth"
          input={(props) => <DatePicker {...props} disabled={isAllInfoUnavailable || isEntity} />}
        />
      )}
    />
  )
}
